import { createReducer } from '@utils';
import { ProfileState } from '@store/profile/types';
import { PROFILE_HANDLERS } from '@store/profile/handlers';
import { profileDefaultState } from './sagas/constants';

const PROFILE_INITIAL_STATE: Readonly<ProfileState> = profileDefaultState;

export default createReducer(PROFILE_INITIAL_STATE, PROFILE_HANDLERS);
